import { FormGroup, TextArea } from '@ksyos/design-system';
import type { OsasTreatmentData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import type { ValidationErrors } from '@frontend/utils';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { TreatmentOptionsKeys } from './utils';

type TreatmentTextInputProps = {
    data: OsasTreatmentData;
    errors: ValidationErrors;
    onChange: (data: Partial<OsasTreatmentData>, validateKeys?: string | string[] | undefined) => void;
    treatmentName: TreatmentOptionsKeys;
};

export function TreatmentTextInput(props: Readonly<TreatmentTextInputProps>) {
    const { data, errors, onChange, treatmentName } = props;

    const hasErrors = Boolean(data.treatment[treatmentName]) && errors.has(`treatment.${treatmentName}`);

    return (
        <FormGroup
            hasErrors={hasErrors}
            isRequired={true}
            key={`${treatmentName}-radio-group`}
            label="Toelichting"
        >
            <TextArea
                error={hasErrors ? getValidationErrorTranslation('any_required') : undefined}
                onChange={({ target: { value } }) => {
                    onChange({ treatment: { ...data.treatment, [treatmentName]: value || true } }, [
                        'treatment',
                        `treatment.${treatmentName}`,
                    ]);
                }}
                value={
                    typeof data.treatment[treatmentName] === 'string' ? (data.treatment[treatmentName] as string) : ''
                }
            />
        </FormGroup>
    );
}
